import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { nameOf } from '../../../../../../../core/functions/string-helpers';
import { FormGroupType } from '../../../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../../../core/models/regexp-pattern/regex-pattern';
import { OrderBillingInformationFormModel } from '../models/order-billing-information-form-model';

@Injectable({
    providedIn: 'root',
})
export class OrderBillingInformationFormService {
    getFormDefinition(): FormGroup<
        FormGroupType<OrderBillingInformationFormModel>
    > {
        return new FormGroup<FormGroupType<OrderBillingInformationFormModel>>({
            organizationName: new FormControl<string | null>(null, [
                Validators.required,
            ]),
            contactName: new FormControl<string | null>(null, [
                Validators.required,
            ]),
            primaryStreetAddress: new FormControl<string | null>(null, [
                Validators.required,
            ]),
            secondaryStreetAddress: new FormControl<string | null>(null),
            city: new FormControl<string | null>(null, [Validators.required]),
            state: new FormControl<string | null>(null, [Validators.required]),
            zipCode: new FormControl<string | null>(null, [
                Validators.required,
                Validators.pattern(RegExPattern.PostalCode),
            ]),
            contactEmail: new FormControl<string | null>(null, [
                Validators.required,
            ]),
        });
    }

    /**
     * Partially completed forms are submittable, so only a malformed zip code blocks saving.
     *
     * @param form The form group representing the order billing information.
     * @returns True if the form is valid, false otherwise.
     */
    isFormValid(
        form: FormGroup<FormGroupType<OrderBillingInformationFormModel>>,
    ): boolean {
        return !form.controls.zipCode.hasError(
            nameOf<typeof Validators>('pattern'),
        );
    }
}
